<template>
  <div class="closure-doctors" :style="maxHeight ? {maxHeight} : null">
    <table>
      <thead>
        <tr>
          <th>醫師</th>
          <th v-for="column in columns" :key="column.key">
            <v-checkbox
              :input-value="columnState(column).all"
              :indeterminate="columnState(column).some"
              :disabled="!hasSelectableDoctors"
              :label="column.label"
              :aria-label="`${column.label}全選或全不選`"
              class="ma-0 pa-0 closure-doctors__toggle"
              color="tiffany-7"
              hide-details
              dense
              @change="$emit('toggle-all', column.key)"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="doctor in orderedDoctors"
          :key="doctor.doctor_code"
          :class="{'closure-doctors__row--off': !doctor.selectable}"
        >
          <td>
            {{ doctor.doctor_name }}醫師
            <span v-if="!doctor.selectable" class="closure-doctors__mode">{{ appointmentModeLabel(doctor) }}</span>
          </td>
          <td v-for="column in columns" :key="column.key">
            <v-checkbox
              v-if="doctor.selectable"
              :input-value="column.checkedCodes.includes(doctor.doctor_code)"
              :aria-label="`${column.label}關閉${doctor.doctor_name}醫師`"
              class="ma-0 pa-0 d-inline-flex"
              color="tiffany-7"
              hide-details
              dense
              @change="$emit('toggle-doctor', column.key, doctor.doctor_code)"
            />
            <span v-else class="closure-doctors__none">—</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  appointmentModeLabel,
  checkState,
  selectableCodes,
  selectableFirst
} from "@/utils/slotClosure";

export default {
  name: "SlotClosureDoctorTable",

  props: {
    doctors: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    maxHeight: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      appointmentModeLabel
    }
  },

  computed: {
    orderedDoctors() {
      return selectableFirst(this.doctors)
    },
    hasSelectableDoctors() {
      return selectableCodes(this.doctors).length > 0
    }
  },

  methods: {
    columnState(column) {
      return checkState(this.doctors, column.checkedCodes)
    }
  }
}
</script>

<style scoped>
.closure-doctors {
  overflow: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.closure-doctors table {
  min-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.closure-doctors th,
.closure-doctors td {
  padding: 9px 14px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  white-space: nowrap;
}

.closure-doctors tbody tr:last-child td {
  border-bottom: none;
}

.closure-doctors th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f5f5f5;
  font-size: 13px;
  font-weight: 500;
  color: #757575;
}

.closure-doctors th:first-child,
.closure-doctors td:first-child {
  position: sticky;
  left: 0;
  width: 100%;
  min-width: 170px;
}

.closure-doctors td:first-child {
  z-index: 1;
  background: #fff;
}

.closure-doctors th:first-child {
  z-index: 2;
}

.closure-doctors__toggle >>> label {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
}

.closure-doctors__row--off td {
  color: #9e9e9e;
}

.closure-doctors__mode {
  margin-left: 8px;
  font-size: 12px;
}

/* 和上下列的勾選框同寬，欄位才對得齊 */
.closure-doctors__none {
  display: inline-block;
  width: 24px;
  text-align: center;
}

@media (max-width: 599px) {
  .closure-doctors th:first-child,
  .closure-doctors td:first-child {
    width: 130px;
    min-width: 130px;
    max-width: 130px;
    padding: 9px 10px;
    white-space: normal;
  }

  .closure-doctors__mode {
    display: block;
    margin-left: 0;
  }
}
</style>
